import React, { Component } from 'react'
import styles from './styles.scss'

import { TimelineMax, TweenMax, Power3, Expo } from 'gsap'

import Cover from 'src/components/cover-img'

import raf from 'src/utils/raf'
import resize from 'src/utils/resize'
import values from 'src/values'
import config from 'src/config'
import components from 'src/utils/components'

export default class Staircase extends Component {
  constructor(props) {
    super(props)

    this.key = `${this.props.type}-${Math.random()}`
  }

  showLeft = () => {
    TweenMax.fromTo(
      this.refs.blockLeftImgContainer,
      0.25,
      { opacity: 0 },
      { opacity: 1 }
    )
    TweenMax.fromTo(this.refs.overflowLeft, 0.25, { x: -10 }, { x: 0 })
    TweenMax.to(this.refs.overflowRight, 0.25, { x: 10 })
    TweenMax.to(this.refs.blockRightImgContainer, 0.25, { opacity: 0 })

    this.refs.bulletRight.classList.add('inactive')
    this.refs.bulletLeft.classList.remove('inactive')
  }

  showRight = () => {
    TweenMax.fromTo(
      this.refs.blockRightImgContainer,
      0.25,
      { opacity: 0 },
      { opacity: 1 }
    )
    TweenMax.fromTo(this.refs.overflowRight, 0.25, { x: 10 }, { x: 0 })
    TweenMax.to(this.refs.overflowLeft, 0.25, { x: -10 })
    TweenMax.to(this.refs.blockLeftImgContainer, 0.25, { opacity: 0 })

    this.refs.bulletLeft.classList.add('inactive')
    this.refs.bulletRight.classList.remove('inactive')
  }

  render() {
    return (
      <div ref="component" className="component staircase">
        <div className="wrapper-content">
          <div className="m-grid-10 grid-wrapper">
            <div ref="content" className="content">
              <h3 dangerouslySetInnerHTML={{ __html: this.props.title }} />
              <p
                style={{ ...this.props.mobile.contentStyle }}
                dangerouslySetInnerHTML={{ __html: this.props.content }}
              />
            </div>
          </div>
        </div>
        <div ref="blockLeftImgContainer" className="block-left-img-container">
          <div ref="overflowLeft" className="overflow-cover">
            <Cover
              ref="cover"
              src={`${process.env.PUBLIC_URL}/img/${
                this.props.mobile
                  ? this.props.mobile.leftImg
                  : this.props.leftImg
              }`}
            />
          </div>
        </div>
        <div
          ref="blockMiddleImgContainer"
          className="block-middle-img-container">
          <img
            src={`${process.env.PUBLIC_URL}/img/${
              this.props.mobile
                ? this.props.mobile.middleImg
                : this.props.middleImg
            }`}
          />
        </div>
        <span className="bg-slide" />
        <div className="bullets-container">
          <span ref="bulletLeft" onClick={this.showLeft} className="bullet" />
          <span
            ref="bulletRight"
            onClick={this.showRight}
            className="bullet inactive"
          />
        </div>
        <div ref="blockRightImgContainer" className="block-right-img-container">
          <div ref="overflowRight" className="overflow-cover">
            <Cover
              ref="cover"
              src={`${process.env.PUBLIC_URL}/img/${
                this.props.mobile
                  ? this.props.mobile.rightImg
                  : this.props.rightImg
              }`}
            />
          </div>
        </div>
        {this.props.mobile.cover && (
          <img
            ref="coverBg"
            className="cover-bg"
            style={{ ...this.props.mobile.coverStyle }}
            src={`${process.env.PUBLIC_URL}/img/${this.props.mobile.cover}`}
          />
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/World/mobile/staircase/index.js